export default __webpack_public_path__ + "static/media/Prophecy_3x2_Hk.127bf4f6.webp";